import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const SettingsView = React.lazy(() => import("./Settings.view"));

const SettingsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <SettingsView />
  </React.Suspense>
);

export default () => <SettingsLoadable />;
